import {css} from '@emotion/react'
import styled from '@emotion/styled'

import {cssTheme} from '@vio/atlas/themes'

import {BaseDatePicker} from '../styles'

const weekDaysStyles = css`
  &.--is-vertical,
  &.--is-single-month {
    &:not(.--show-week-days) {
      .calendar-week-days-wrapper {
        display: none;
      }
    }
  }
`

const weekendsStyles = css`
  .weekends {
    background: transparent;
  }
`

const selectedDaysStyles = css`
  .start > button {
    /*use box-shadow instead of outline due to safari bug with rounded corners*/
    box-shadow: 0 0 0 1pt ${cssTheme.colors.border.interactive.primary};
  }
`

const monthDaysStyles = css`
  .calendar-wrapper {
    width: 100%;
    table-layout: fixed;
    border-spacing: ${cssTheme.layout.spacing.s200};
    padding: 0;
  }
  &:not(.--is-single-month) {
    .calendar-wrapper {
      padding: 0 17px;
    }
  }
`

export const AvailabilityDatePickerContainer = styled(BaseDatePicker)`
  ${monthDaysStyles}
  ${weekDaysStyles}
  ${weekendsStyles}
  ${selectedDaysStyles}
`
